var map = {
	"app/birthday-link/birthday-link.module": [
		"./src/app/birthday-link/birthday-link.module.ts",
		"app-birthday-link-birthday-link-module"
	],
	"app/pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"common",
		"app-pages-pages-module"
	],
	"app/ranking-link/ranking-link.module": [
		"./src/app/ranking-link/ranking-link.module.ts",
		"common",
		"app-ranking-link-ranking-link-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;